import React from "react";
import {Space} from "antd";
import cx from "classnames";
import {Element} from "react-scroll";
import styles from "@/page-components/detail/Job/styles.module.less";
import EjcBlocks from "@/page-components/detail/Job/ejc_blocks";
import Ad from "@/page-components/detail/Ad";
import Plan from "@/page-components/detail/Plan";
import Data from "@/page-components/detail/data";
import Qa from "@/page-components/detail/Qa";
import {TExamDetailFixedDataType} from "@/types";

type TJobLeftMobile = {
  data:TExamDetailFixedDataType
}

const JobLeftMobile:React.FC<TJobLeftMobile> = ({data}) => {
  return (
    <div className={styles.job_area_left}>
      <div className={styles.item}>
        <div className={styles.job_subtitle}>适合人群</div>
        <div className={cx(styles.job_text,styles.job_text_offset)}>{data?.ability_demanded.suit_people}</div>
      </div>
      <div className={styles.item}>
        <div className={styles.job_subtitle}>认证回报</div>
        <div>
          <div className={cx(styles.job_subtitle,styles.job_secondtitle)}>{data.short_cn_title}证书</div>
          <div className={styles.job_text}>{data?.ability_demanded.reward}</div>
        </div>
        <img src={`/img/cert_example/${data.type}_example.jpg`} className={styles.img} alt=""/>
      </div>
      <div className={cx(styles.item,styles.last_child)}>
        <div className={styles.job_subtitle}>能力要求</div>
        <div className={styles.job_text_offset}>
          {data?.ability_demanded.url && <img src={data.ability_demanded.url} className={styles.img} alt="" />}
          {data?.ability_demanded.text.map((text,index) => {
            if (data.ability_demanded.url){
              return (
                <div key={text} className={cx(styles.example_row,index === 0 && styles.first_row)}>
                  <Space>
                    <div className={cx(styles.example_circle,styles[`example${index+1}`])}/>
                    <p className={cx(styles.job_subtitle,styles.job_text)}>{text}</p>
                  </Space>
                </div>
              )
            }
            return (
              <div key={text} className={cx(styles.example_row,index === 0 && styles.first_row)}>
                <p className={cx(styles.job_subtitle,styles.job_text)}>{text}</p>
              </div>
            )
          })}
        </div>
      </div>
      <EjcBlocks data={data}/>
      {data && <Ad ad_data={data.ad}/>}
      <Element name="test5" className="element">
        <Plan data={data}/>
      </Element>
      <Data data={data?.document} path_name={data?.short_english_title}/>
      <Element name="test6" className="element">
        <Qa />
      </Element>
    </div>
  )
}
export default JobLeftMobile;
